@if (avatar) {
  <img class="user-avatar" [ngClass]="size" [src]="avatar"/>
} @else {
  <i class="mdi mdi-account-circle" [ngClass]="size"></i>
}
